/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Event_Voice_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Event voice updated successfully" |
*
* @param {Voices_Event_Voice_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_event_voice_updated_toast = /** @type {((inputs?: Voices_Event_Voice_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Event_Voice_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voix de l'evenement mise a jour avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Event-Sprache erfolgreich aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Voce dell'evento aggiornata correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Голосовое сообщение события успешно обновлено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La voz del evento se actualizó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件语音已成功更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント音声が正常に更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की आवाज़ सफलतापूर्वक अपडेट हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voz do evento atualizada com sucesso")
	return /** @type {LocalizedString} */ ("Event voice updated successfully")
});